import * as modelsGet from "../models/get";
import { getStatus } from "../api/status";

var status: modelsGet.IStatus[];

/**
 * Gibt alle Status Einträge zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getStatusAsync(reload: boolean = false): Promise<modelsGet.IStatus[]>
{
    if (status == null || reload)
    {
        status = await getStatus();
    }

    return status;
}